<h3 class="head-block">
  {{ 'onboarding.addressInfo.enterAddress' | translate }}
</h3>

<form
  [formGroup]="contractorAddressForm"
  id="contractorAddressForm"
  name="contractorAddressForm"
  [ngClass]="{ 'mailing-address-requested': !isOnlyPhysicalAddress }"
>
  <div class="address-responsive">
    <div class="physicalAddress">
      <div
        [formGroup]="addressFormGroups[physicalAddressIndex]"
        class="form-wrap"
      >
        <div class="title">
          <p>{{ 'onboarding.addressInfo.physicalAddress' | translate }}</p>
        </div>

        <div class="row">
          <div>
            <div class="street">
              <label>{{ 'onboarding.addressInfo.street1' | translate }}</label>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  required
                  formControlName="street1"
                  data-test-id="street1"
                  aria-label="street1 Input"
                  minlength="2"
                  maxlength="50"
                  required
                />
                <mat-error
                  ><div
                    class="input-error"
                    *ngIf="addressFormGroups[physicalAddressIndex]?.get('street1')?.errors?.['required']"
                  >
                    <cigna-icon
                      type="exclamation-triangle"
                      class="alert-icon"
                    ></cigna-icon>
                    {{ 'global.required' | translate }}
                  </div>
                  <div
                    class="input-error"
                    *ngIf="
                      addressFormGroups[physicalAddressIndex]?.get('street1')?.errors?.['minlength']
                      "
                  >
                    <cigna-icon
                      type="exclamation-triangle"
                      class="alert-icon"
                    ></cigna-icon>
                    {{ 'forgotUsername.firstNameMinLength' | translate }}
                  </div>
                </mat-error>
              </mat-form-field>
            </div>

            <div class="street">
              <label>{{ 'onboarding.addressInfo.street2' | translate }}</label>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  formControlName="street2"
                  minlength="2"
                  maxlength="50"
                />

                <mat-error>
                  <div
                    class="input-error"
                    *ngIf="
                      addressFormGroups[physicalAddressIndex]?.get('street2')?.errors?.['minlength']
                      "
                  >
                    <cigna-icon
                      type="exclamation-triangle"
                      class="alert-icon"
                    ></cigna-icon>
                    {{ 'forgotUsername.firstNameMinLength' | translate }}
                  </div>
                </mat-error>
              </mat-form-field>
            </div>

            <div class="city">
              <label>{{ 'onboarding.addressInfo.city' | translate }}</label>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  formControlName="city"
                  minlength="2"
                  maxlength="50"
                  required
                />

                <mat-error
                  ><div
                    class="input-error"
                    *ngIf="addressFormGroups[physicalAddressIndex]?.get('city')?.errors?.['required']"
                  >
                    <cigna-icon
                      type="exclamation-triangle"
                      class="alert-icon"
                    ></cigna-icon>
                    {{ 'global.required' | translate }}
                  </div>

                  <div
                    class="input-error"
                    *ngIf="
                      addressFormGroups[physicalAddressIndex]?.get('city')?.errors?.['minlength']
                      "
                  >
                    <cigna-icon
                      type="exclamation-triangle"
                      class="alert-icon"
                    ></cigna-icon>
                    {{ 'forgotUsername.firstNameMinLength' | translate }}
                  </div>
                </mat-error>
              </mat-form-field>
            </div>

            <div class="State">
              <label>{{ 'onboarding.addressInfo.state' | translate }}</label>

              <mat-form-field appearance="outline">
                <mat-select
                  placeholder="Select"
                  disableOptionCentering
                  matInput
                  [ngModel]
                  state="state"
                  formControlName="state"
                  required
                >
                  <mat-option value="Select" [disabled]="true">
                    {{ 'global.select' | translate }}
                  </mat-option>

                  <mat-option
                    *ngFor="let country of countries"
                    [value]="country"
                  >
                    {{ country }}
                  </mat-option>
                </mat-select>

                <mat-error>
                  <div
                    class="input-error"
                    *ngIf="
                      addressFormGroups[physicalAddressIndex]
                        ?.get('state')
                        ?.hasError('required') &&
                      addressFormGroups[physicalAddressIndex]?.get('state')
                        ?.pristine
                    "
                  >
                    <cigna-icon
                      type="exclamation-triangle"
                      class="alert-icon"
                    ></cigna-icon>
                    {{ 'global.required' | translate }}
                  </div>
                </mat-error>
              </mat-form-field>
            </div>

            <div class="zipcode">
              <label>{{ 'onboarding.addressInfo.zipCode' | translate }}</label>
              <mat-form-field appearance="outline">
                <input
                  class="zipcodeTxt"
                  (keypress)="numberOnly($event)"
                  matInput
                  required
                  type="text"
                  formControlName="zipcode"
                  maxlength="5"
                  min="0"
                  max="99999"
                  pattern="\d*"
                  onkeypress="if(this.value.length>=5) return false;"
                />

                <mat-error
                  ><div
                    class="input-error"
                    *ngIf="addressFormGroups[physicalAddressIndex]?.get('zipcode')?.errors?.['required']"
                  >
                    <cigna-icon
                      type="exclamation-triangle"
                      class="alert-icon"
                    ></cigna-icon>
                    {{ 'global.required' | translate }}
                  </div>
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mailingAddress">
      <div class="title">
        <p class="copy-address">
          {{ 'onboarding.addressInfo.mailingAddress' | translate }}
        </p>
      </div>
      <div class="same-address">
        <mat-checkbox
          [checked]="isOnlyPhysicalAddress"
          (change)="onlyPhysicalAddressChecked($event.checked)"
          >{{ 'onboarding.addressInfo.sameAs' | translate }}</mat-checkbox
        >
      </div>

      <div
        class="form-wrap-2"
        [formGroup]="addressFormGroups[mailingAddressIndex]"
        *ngIf="shouldShowMailingAddressForm"
      >
        <div class="street">
          <label>{{ 'onboarding.addressInfo.street1' | translate }}</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              formControlName="mastreet1"
              minlength="2"
              maxlength="50"
              required
            />

            <mat-error
              ><div
                class="input-error"
                *ngIf="addressFormGroups[mailingAddressIndex]?.get('mastreet1')?.errors?.['required']"
              >
                <cigna-icon
                  type="exclamation-triangle"
                  class="alert-icon"
                ></cigna-icon>
                {{ 'global.required' | translate }}
              </div>

              <div
                class="input-error"
                *ngIf="
                addressFormGroups[mailingAddressIndex]?.get('mastreet1')?.errors?.['minlength']
                "
              >
                <cigna-icon
                  type="exclamation-triangle"
                  class="alert-icon"
                ></cigna-icon>
                {{ 'forgotUsername.firstNameMinLength' | translate }}
              </div>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="street">
          <label>{{ 'onboarding.addressInfo.street2' | translate }}</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              formControlName="mastreet2"
              minlength="2"
              maxlength="50"
            />

            <mat-error>
              <div
                class="input-error"
                *ngIf="
                addressFormGroups[mailingAddressIndex]?.get('mastreet2')?.errors?.['minlength']
                "
              >
                <cigna-icon
                  type="exclamation-triangle"
                  class="alert-icon"
                ></cigna-icon>
                {{ 'forgotUsername.firstNameMinLength' | translate }}
              </div>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="city">
          <label>{{ 'onboarding.addressInfo.city' | translate }}</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              formControlName="macity"
              minlength="2"
              maxlength="50"
              required
            />

            <mat-error
              ><div
                class="input-error"
                *ngIf="addressFormGroups[mailingAddressIndex]?.get('macity')?.errors?.['required']"
              >
                <cigna-icon
                  type="exclamation-triangle"
                  class="alert-icon"
                ></cigna-icon>
                {{ 'global.required' | translate }}
              </div>

              <div
                class="input-error"
                *ngIf="
              addressFormGroups[mailingAddressIndex]?.get('macity')?.errors?.['minlength']
              "
              >
                <cigna-icon
                  type="exclamation-triangle"
                  class="alert-icon"
                ></cigna-icon>
                {{ 'forgotUsername.firstNameMinLength' | translate }}
              </div>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="State">
          <label>{{ 'onboarding.addressInfo.state' | translate }}</label>

          <mat-form-field appearance="outline">
            <mat-select
              placeholder="Select"
              disableOptionCentering
              matInput
              [ngModel]
              state="state"
              formControlName="state"
              required
            >
              <mat-option value="Select" [disabled]="true">
                {{ 'global.select' | translate }}
              </mat-option>

              <mat-option *ngFor="let country of countries" [value]="country">
                {{ country }}
              </mat-option>
            </mat-select>

            <mat-error>
              <div
                class="input-error"
                *ngIf="
                  addressFormGroups[mailingAddressIndex]
                    ?.get('state')
                    ?.hasError('required') &&
                  addressFormGroups[mailingAddressIndex]?.get('state')?.pristine
                "
              >
                <cigna-icon
                  type="exclamation-triangle"
                  class="alert-icon"
                ></cigna-icon>
                {{ 'global.required' | translate }}
              </div>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="zipcode">
          <label>{{ 'onboarding.addressInfo.zipCode' | translate }}</label>
          <mat-form-field appearance="outline">
            <input
              type="text"
              class="zipcodeTxt"
              (keypress)="numberOnly($event)"
              matInput
              formControlName="mazipcode"
              maxlength="5"
              min="0"
              max="99999"
              pattern="\d*"
              onkeypress="if(this.value.length>=5) return false;"
              required
            />
            <mat-error
              ><div
                class="input-error"
                *ngIf="addressFormGroups[mailingAddressIndex]?.get('mazipcode')?.errors?.['required']"
              >
                <cigna-icon
                  type="exclamation-triangle"
                  class="alert-icon"
                ></cigna-icon>
                {{ 'global.required' | translate }}
              </div>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  <div class="mailingAddress-responsive">
    <div class="title">
      <p class="copy-address">
        {{ 'onboarding.addressInfo.mailingAddress' | translate }}
      </p>
    </div>
    <div class="same-address">
      <mat-checkbox
        [checked]="isOnlyPhysicalAddress"
        (change)="onlyPhysicalAddressChecked($event.checked)"
        >{{ 'onboarding.addressInfo.sameAs' | translate }}</mat-checkbox
      >
    </div>

    <div
      class="form-wrap-2"
      [formGroup]="addressFormGroups[mailingAddressIndex]"
      *ngIf="shouldShowMailingAddressForm"
    >
      <div class="street">
        <label>{{ 'onboarding.addressInfo.street1' | translate }}</label>

        <mat-form-field appearance="outline">
          <input
            matInput
            formControlName="mastreet1"
            minlength="2"
            maxlength="50"
            required
          />

          <mat-error
            ><div
              class="input-error"
              *ngIf="addressFormGroups[mailingAddressIndex]?.get('mastreet1')?.errors?.['required']"
            >
              <cigna-icon
                type="exclamation-triangle"
                class="alert-icon"
              ></cigna-icon>
              {{ 'global.required' | translate }}
            </div>

            <div
              class="input-error"
              *ngIf="
              addressFormGroups[mailingAddressIndex]?.get('mastreet1')?.errors?.['minlength']
              "
            >
              <cigna-icon
                type="exclamation-triangle"
                class="alert-icon"
              ></cigna-icon>
              {{ 'forgotUsername.firstNameMinLength' | translate }}
            </div>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="street">
        <label>{{ 'onboarding.addressInfo.street2' | translate }}</label>
        <mat-form-field appearance="outline">
          <input
            matInput
            formControlName="mastreet2"
            minlength="2"
            maxlength="50"
          />

          <mat-error>
            <div
              class="input-error"
              *ngIf="
              addressFormGroups[mailingAddressIndex]?.get('mastreet2')?.errors?.['minlength']
              "
            >
              <cigna-icon
                type="exclamation-triangle"
                class="alert-icon"
              ></cigna-icon>
              {{ 'forgotUsername.firstNameMinLength' | translate }}
            </div>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="city">
        <label>{{ 'onboarding.addressInfo.city' | translate }}</label>
        <mat-form-field appearance="outline">
          <input
            matInput
            formControlName="macity"
            minlength="2"
            maxlength="50"
            required
          />

          <mat-error
            ><div
              class="input-error"
              *ngIf="addressFormGroups[mailingAddressIndex]?.get('macity')?.errors?.['required']"
            >
              <cigna-icon
                type="exclamation-triangle"
                class="alert-icon"
              ></cigna-icon>
              {{ 'global.required' | translate }}
            </div>

            <div
              class="input-error"
              *ngIf="
              addressFormGroups[mailingAddressIndex]?.get('macity')?.errors?.['minlength']
              "
            >
              <cigna-icon
                type="exclamation-triangle"
                class="alert-icon"
              ></cigna-icon>
              {{ 'forgotUsername.firstNameMinLength' | translate }}
            </div>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="State">
        <label>{{ 'onboarding.addressInfo.state' | translate }}</label>

        <mat-form-field appearance="outline">
          <mat-select
            placeholder="Select"
            disableOptionCentering
            matInput
            [ngModel]
            state="state"
            formControlName="state"
            required
          >
            <mat-option value="Select" [disabled]="true">
              {{ 'global.select' | translate }}
            </mat-option>

            <mat-option *ngFor="let country of countries" [value]="country">
              {{ country }}
            </mat-option>
          </mat-select>

          <mat-error>
            <div
              class="input-error"
              *ngIf="
                addressFormGroups[mailingAddressIndex]
                  ?.get('state')
                  ?.hasError('required') &&
                addressFormGroups[mailingAddressIndex]?.get('state')?.pristine
              "
            >
              <cigna-icon
                type="exclamation-triangle"
                class="alert-icon"
              ></cigna-icon>
              {{ 'global.required' | translate }}
            </div>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="zipcode">
        <label>{{ 'onboarding.addressInfo.zipCode' | translate }}</label>
        <mat-form-field appearance="outline">
          <input
            type="text"
            class="zipcodeTxt"
            matInput
            formControlName="mazipcode"
            maxlength="5"
            min="0"
            max="99999"
            pattern="\d*"
            onkeypress="if(this.value.length>=5) return false;"
            required
          />

          <mat-error
            ><div
              class="input-error"
              *ngIf="addressFormGroups[mailingAddressIndex]?.get('mazipcode')?.errors?.['required']"
            >
              <cigna-icon
                type="exclamation-triangle"
                class="alert-icon"
              ></cigna-icon>
              {{ 'global.required' | translate }}
            </div>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="btns">
    <button
      type="submit"
      mat-raised-button
      cg-mat-btn-type="primary"
      [disabled]="addressForms.invalid"
      class="ls-button-fill"
      data-test-id="btn-submit"
      (click)="onContinue()"
    >
      {{ 'global.continue' | translate }}
    </button>
    <span
      mat-button
      class="cancel-btn"
      data-test-id="btn-cancel"
      (click)="cancelForm()"
      >{{ 'global.cancel' | translate }}</span
    >
  </div>
</form>
